<template>

	<nav id="Nav">

		<router-link :class="{active: isActive('/home')}" to="/home">{{ $t('home') }}</router-link>
		<router-link :class="{active: isActive('/metrology')}" to="/metrology">{{ $t('metrology') }}</router-link>
		<router-link :class="{active: isActive('/inspection')}" to="/inspection">{{ $t('inspection') }}</router-link>
		<router-link :class="{active: isActive('/analysis')}" to="/analysis">{{ $t('analysis') }}</router-link>
		<router-link :class="{active: isActive('/applications')}" to="/applications">{{ $t('applications') }}</router-link>
		<router-link :class="{active: isActive('/x-ray_series')}" to="/x-ray_series">{{ $t('xraySeries') }}</router-link>
		<router-link :class="{active: isActive('/why_x-ray')}" to="/why_x-ray">{{ $t('whyXray') }}</router-link>

		<div class="Nav__icon">

			<img src="../../assets/nav-icon.png" alt="Active" />

		</div>

	</nav>

</template>

<script>

	import routes from "../../routes";
	import i18n from '@/plugins/i18n';

	export default {
		mounted () {
			document.querySelector('#Nav .Nav__icon').style.left = this.getRoute(this.$route.name).iconPosition[i18n.locale] + 'px';
		},
		watch: {
			'$route' () {
				document.querySelector('#Nav .Nav__icon').style.left = this.getRoute(this.$route.name).iconPosition[i18n.locale] + 'px';
			}
		},
		methods: {
			getRoute (routeName) {
				for (let r of routes) {
					if (r.name === routeName) {
						return r;
					}
				}

				return null;
			},
			isActive (pre) {
				return (this.$route.path.length >= pre.length && this.$route.path.substr(0, pre.length) === pre);
			}
		}

	};

</script>